module.exports = __webpack_public_path__ + "img/yapdictionary.cdbd3f49.jpg";